// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { Utilities } from '../app/utils/utilities';


const config = window.__config || {
	useFingerprintPro: false,
	fingerprintProKey: "",
	fpEndpoint:"",
	daysForDuidRefresh: -1,
	reconfirmContactTimeout: 5,
	reconfirmEmailPattern: "^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$",
	sampleChainTimeout: 5,
	baseApi: "https://api-surveys.sample-cube.com/api/v1",
	rfgTimeout: 2,
	rfgLib: "//hosting.researchforgood.com/js/df-fp.js",
	dqcTimeout: 8,
	verisoulEnabled: false
};

export const environment = {
	verisoul: {
		enabled: config.verisoulEnabled === true,
		production: true,
		apiUrl: config.prodVerisoulSdkScriptUrl || 'https://v.userflow.com/bundle.js',
		projectId: config.prodVerisoulProjectId || '59a6361a-106d-4363-b18f-abe1fa96022c'
	},
	fingerprintProKey: {
		val: config.fingerprintProKey
	},
	useFingerprintPro: {
		val: config.useFingerprintPro
	},
	fpEndpoint: {
		val: config.fpEndpoint
	},
	daysForDuidRefresh: {
		val: config.daysForDuidRefresh
	},
	production: true,
	reconfirmContact: {
		apiGetUrl: "https://api.panel-cube.com/api/user/v2/paymentaddress?TokenId={token}",
		apiUpdateUrl: "https://api.panel-cube.com/api/user/v2/updatepaymentaddress",
		timeout: config.reconfirmContactTimeout || 5,
		cache: true,
		emailPattern:"^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$"
	},

	sampleChain: {
		key: "e4850f69-59f9-4beb-8bc7-98a94c3112b8",
		privateKey:"52f75913-0e0a-4599-a290-86688cd21f0d",
		lib: "//prod.rtymgt.com/static/js/993xddk3/scdvcCapture-v1-1.min.js?ver=20260908.2",
		apiUrl: "https://prod.rtymgt.com/api/v4/respondents/",
		timeout: config.sampleChainTimeout || 5,
		cache: true,
		source:"SampleCube",
		mfr: 1
	},
	coreSurveyDropCookie: {
		lib: "//gwiqcdn.globalwebindex.net/gwiq/gwiq.js",
		timeout: 2
	},
	rfgFingerPrint: {
		lib: config.rfgLib || "//survey.saysoforgood.com/utils/rfg-fp.js",
		timeout:config.rfgTimeout || 2,
		cache: true
	},
	comScore: {
		lib: config.comScoreLib || "//sb.scorecardresearch.com/p?c1=14&c2=37581797&c4=s&cj=1&c3=",
		timeout:config.comScoreTimeout || 2,
		cache: true
	},
	dqc:{
		enabled: config.isDQCEnabled !== false,
		timeout:config.dqcTimeout || 8,
		cache: true
	},
	baseApi: config.baseApi || "https://api-surveys.sample-cube.com/api/v1",
	appInsights: {
		instrumentationKey: "306a2f62-2435-4455-a53f-db84c3bb1a7f",
		disableExceptionTracking: false,
		disableAjaxTracking: false
	},
	buildNumber: "20260908.2",
	envName: "{EnvName}",
	mbdPixelUrl:
		"https://secure.insightexpressai.com/adserver/PanelistPartnerESI.aspx?PartnerID=10069&Iso={country}&PanelistID={userid}&redir=https%3A%2F%2Fsample-cube.com",
	linkedInAuthUrl:
		"https://externalauth.sample-cube.com/Linkedin/CheeseCakeAuth",
	maintenance: {
		enabled: config.maintenanceEnabled === undefined ? false : config.maintenanceEnabled,
		bypassKey: config.maintenanceBypassKey || ''
	},
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
